import { createContext } from 'react'

import { DetectPageReturnType } from 'hooks/useDetectSCpage'

import { CarePathColorPattern } from '../constant'

export type CarePathDefaultContextType = {
  colorArr: any
  navigating: any
  mappingIconList: any
  keyID: string
  detectPage: DetectPageReturnType
  activeTheme?: CarePathColorPattern
}

export const CarePathDefaultContext = createContext<CarePathDefaultContextType>(
  {} as CarePathDefaultContextType,
)
